/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_PurchasedInputs */

const en_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const id_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ms_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ca_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const cs_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const da_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const de_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const et_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const es_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const fr_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const hr_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const it_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const lv_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const lt_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const hu_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const nl_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const nb_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const pl_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const pt_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ro_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const sk_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const sl_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const fi_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const sv_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const vi_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const tr_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const el_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const bg_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ru_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const sr_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const uk_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ka_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const hi_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const th_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ko_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const zh_tw_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

const ja_status_purchased = /** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`purchased`)
};

/** @type {(inputs: Status_PurchasedInputs) => LocalizedString} */
const zh_status_purchased = en_status_purchased;

/**
* | output |
* | --- |
* | "purchased" |
*
* @param {Status_PurchasedInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const status_purchased = /** @type {((inputs?: Status_PurchasedInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_PurchasedInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_status_purchased(inputs)
	if (locale === "ms") return ms_status_purchased(inputs)
	if (locale === "ca") return ca_status_purchased(inputs)
	if (locale === "cs") return cs_status_purchased(inputs)
	if (locale === "da") return da_status_purchased(inputs)
	if (locale === "de") return de_status_purchased(inputs)
	if (locale === "et") return et_status_purchased(inputs)
	if (locale === "es") return es_status_purchased(inputs)
	if (locale === "fr") return fr_status_purchased(inputs)
	if (locale === "hr") return hr_status_purchased(inputs)
	if (locale === "it") return it_status_purchased(inputs)
	if (locale === "lv") return lv_status_purchased(inputs)
	if (locale === "lt") return lt_status_purchased(inputs)
	if (locale === "hu") return hu_status_purchased(inputs)
	if (locale === "nl") return nl_status_purchased(inputs)
	if (locale === "nb") return nb_status_purchased(inputs)
	if (locale === "pl") return pl_status_purchased(inputs)
	if (locale === "pt") return pt_status_purchased(inputs)
	if (locale === "ro") return ro_status_purchased(inputs)
	if (locale === "sk") return sk_status_purchased(inputs)
	if (locale === "sl") return sl_status_purchased(inputs)
	if (locale === "fi") return fi_status_purchased(inputs)
	if (locale === "sv") return sv_status_purchased(inputs)
	if (locale === "vi") return vi_status_purchased(inputs)
	if (locale === "tr") return tr_status_purchased(inputs)
	if (locale === "el") return el_status_purchased(inputs)
	if (locale === "bg") return bg_status_purchased(inputs)
	if (locale === "ru") return ru_status_purchased(inputs)
	if (locale === "sr") return sr_status_purchased(inputs)
	if (locale === "uk") return uk_status_purchased(inputs)
	if (locale === "ka") return ka_status_purchased(inputs)
	if (locale === "hi") return hi_status_purchased(inputs)
	if (locale === "th") return th_status_purchased(inputs)
	if (locale === "ko") return ko_status_purchased(inputs)
	if (locale === "zh") return zh_status_purchased(inputs)
	if (locale === "zh-tw") return zh_tw_status_purchased(inputs)
	if (locale === "ja") return ja_status_purchased(inputs)
	return en_status_purchased(inputs)
});